import { updateRingPickupExpectedDate } from "@/api/providerDashboard";
import { formatRingPickupDate } from "@/utils/ringPickupProgress";

export default {
  ringPickupButtonLabel(item) {
    const pickupDate = formatRingPickupDate(item && item.ringPickupExpectedAt);
    return pickupDate ? `반지 수령일 (${pickupDate})` : "반지 수령일";
  },
  openRingPickupDialog(item) {
    this.ringPickupSchedule = item;
    this.showRingPickupDialog = true;
  },
  closeRingPickupDialog() {
    if (this.savingRingPickupDate) return;
    this.showRingPickupDialog = false;
    this.ringPickupSchedule = null;
  },
  async saveRingPickupDate(ringPickupExpectedDate) {
    if (!this.ringPickupSchedule || !this.ringPickupSchedule._id) return;

    this.savingRingPickupDate = true;
    try {
      await updateRingPickupExpectedDate(
        this.ringPickupSchedule._id,
        ringPickupExpectedDate
      );
      this.$message.success("반지 수령 예정일이 저장되었습니다.");
      this.showRingPickupDialog = false;
      this.ringPickupSchedule = null;
      await this.loadSchedules();
    } catch (error) {
      const responseMessage =
        error.response && error.response.data && error.response.data.message;
      this.$message.error(
        responseMessage || "반지 수령 예정일을 저장하지 못했습니다."
      );
    } finally {
      this.savingRingPickupDate = false;
    }
  },
};
